var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.8428V4.69104C13.5 4.36473 13.3704 4.05179 13.1396 3.82105C12.9089 3.59032 12.596 3.46069 12.2697 3.46069H8.10862C7.88009 3.46069 7.65608 3.39703 7.46169 3.27685C7.2673 3.15668 7.11023 2.98474 7.00808 2.78031L6.45811 1.68038C6.35591 1.47586 6.19874 1.30386 6.00424 1.18368C5.80973 1.0635 5.58559 0.999894 5.35695 1H2.42688C2.10057 1 1.78763 1.12963 1.55689 1.36036C1.32616 1.5911 1.19653 1.90404 1.19653 2.23035V10.8428C1.19653 11.1691 1.32616 11.482 1.55689 11.7128C1.78763 11.9435 2.10057 12.0731 2.42688 12.0731H12.2697C12.596 12.0731 12.9089 11.9435 13.1396 11.7128C13.3704 11.482 13.5 11.1691 13.5 10.8428Z",
    fill: "#6AA287",
    fillOpacity: 0.42,
    stroke: "#6AA287",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderActive);
export default __webpack_public_path__ + "static/media/folder-active.5bd7b18d136d4c8499ba8ba18ad2186b.svg";
export { ForwardRef as ReactComponent };